import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = { class: "text-center" }

import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {onMounted, reactive, ref} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig} from "@/AppConfig";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {LocationInfo} from "@/models/location/LocationInfo";
import {LocationDisdiInfo} from "@/models/location/LocationDisdiInfo";



export default /*#__PURE__*/_defineComponent({
  __name: 'LocationDisdiEditor',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();
const locationService = new LocationService();

const result = ref(globalStore.modal.contentObject);

const loading = ref<boolean>(false);
const selectedRowsInitialized = ref<boolean>(false);

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  enableTextSelection: true,
  autoHeight: true,
  selectionMode: {
    cell: false,
    row: true,
    checkbox: checkboxColumnConfig,
    showCheckAll: true,
    deselectFilteredOutRecords: true,
  },
  columns : {
    data: [
      {
        id: 'name',
        field : 'name',
        text: t('popups.locations.name'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'street',
        field : 'street',
        text: t('popups.locations.street'),
        sortable: true,
        type: 'template',
        template: (value) => {
          if(value.record.street != null) {
						return StringHelper.xss`${value.record.street ?? ""} ${value.record.streetNumber ?? ""}`;
          } else {
            return ""
          }
        },
      },
      {
        id:'postalCode',
        field : 'postalCode',
        text: t('popups.locations.postalCode'),
        sortable: true,
        type: 'template',
        template: ({record}) => {
					return StringHelper.xss`${record.data.postalCode ?? ""} ${record.data.city ?? ""}`;
        },
      },
      {
        id: 'group2Name',
        text : t('locations.grid.group2Name'),
        field : 'group2Name',
        filterable: false,
        hideable: true,
      },
      {
        id: 'group1Name',
        text : t('locations.grid.group1Name'),
        field : 'group1Name',
        flex: 1,
        filterable: false,
        hideable: true,
      },
      {
        id: 'controlCenterName',
        text : t('locations.grid.controlCenterName'),
        field : 'controlCenterName',
        flex: 1,
        filterable: false,
        hideable: true,
      },
    ],
  },
  listeners: {
    selectionChange(event:any) {
      if(!selectedRowsInitialized.value) return;
      syncWithPropsData(event.selected.map(l=>l.data), event.deselected.map(l=>l.data))
    },
  },
  store: gridStore,
}
const gridConfig = reactive(useGridConfig);

const setGridData = async ()=>{
  const locations = await locationService.getLocations("display", ErrorLocationType.popup);

  gridStore.setStoreData(locations);

  // set selected locations in table
  grid.value.instance.value.selectRows(locations?.filter(l => l.hasDisdi).map(l => l.id))
  selectedRowsInitialized.value = true;
}

const syncWithPropsData = (selected:Array<LocationInfo>, deselected:Array<LocationInfo>)=>{
  for(const location of selected){
    const foundLocationDisdi = result.value.find(ld => ld.id === location.id);
    if(foundLocationDisdi){
      const i = result.value.indexOf(foundLocationDisdi);
      result.value[i] = new LocationDisdiInfo(location.id, true)
      continue;
    }
    result.value.push(new LocationDisdiInfo(location.id, true))
  }

  for(const location of deselected){
    const foundLocationDisdi = result.value.find(ld => ld.id === location.id);
    if(foundLocationDisdi){
      const i = result.value.indexOf(foundLocationDisdi);
      result.value[i] = new LocationDisdiInfo(location.id, false)
      continue;
    }
    result.value.push(new LocationDisdiInfo(location.id, false))
  }

  globalStore.modal.contentObject = result.value;
}

onMounted(async () => {
  loading.value = true
  await setGridData();
  loading.value = false;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(GridInputFilter), {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, loading.value]
    ])
  ], 64))
}
}

})